import { Capacitor } from "@capacitor/core";

// The production web origin that public/share links must point to. In the
// Capacitor WKWebView window.location.origin is "capacitor://localhost", which
// is useless to anyone we hand a link to — so on native we substitute the real
// hosted origin. On web we keep window.location.origin so preview/branch
// deploys and local dev produce self-referential links.
const PUBLIC_ORIGIN = "https://www.affinage.recipes";

export function publicOrigin(): string {
  return Capacitor.isNativePlatform() ? PUBLIC_ORIGIN : window.location.origin;
}

// Build a public link from an app route (the HashRouter path, with a leading
// "/"). E.g. publicLink("/r/abc123") -> "https://.../r/abc123".
//
// Note the missing "#". These links get pasted into iMessage and Slack, and a
// fragment never reaches a server, so a "/#/r/abc" link can only ever unfurl
// as the app's generic title — every recipe would preview identically. The
// path form gives api/share.ts something to answer with the recipe's own
// title and photo; adoptPathLink() below puts the route back on the hash once
// the app boots, so HashRouter is none the wiser.
export function publicLink(path: string): string {
  return `${publicOrigin()}${path}`;
}

// Routes that are served as real paths for the sake of link previews. Anything
// else keeps arriving on the hash, as it always has.
const PATH_ROUTES = /^\/r\/[^/]+(\/v\/\d+)?\/?$/;

/**
 * Move a path-form share link onto the hash before the router mounts.
 *
 * Called from main.tsx ahead of the first render, so HashRouter reads the
 * corrected location on construction and nothing flashes. This is what makes
 * the path links work everywhere — the Vercel function, `vite dev`, and the
 * index.html rewrite that catches a preview deploy without the function.
 */
export function adoptPathLink(): void {
  const { pathname, search, hash } = window.location;
  if (hash || !PATH_ROUTES.test(pathname)) return;
  const route = pathname.replace(/\/$/, "");
  window.history.replaceState(null, "", `/#${route}${search}`);
}
